import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { LocalStorageService } from '../services/local-storage.service';
import { renewalPathOf } from '@app/shared/subscription-routes';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private _localStorageService: LocalStorageService,
    private _router: Router) {}


  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    const authToken = this._localStorageService.getValueByKey('userToken');
    const isTokenExpired = (token: string) => {
      return Date.now() >= (JSON.parse(atob(token.split('.')[1]))).exp * 1000;
    };

    if (authToken && !isTokenExpired(authToken)) {
      return true;
    } else {
      // A visitor following a Renew Subscription link (for example from an email) comes back to that page after
      // signing in; every other page keeps the plain redirect.
      const returnUrl = renewalPathOf(state.url);
      if (returnUrl) {
        this._router.navigate(['account/login'], { queryParams: { returnUrl } });
      } else {
        this._router.navigate(['account/login']);
      }
      this._localStorageService.deleteValueByKey('userToken');
      return false;
    }
  }
}
